export default "/assets/images/mila-feed-05.24f3d36ab74ff3ff.mp4";